import { z } from "zod";
import { Uid } from "./docs.js";
/**
 * Task history and inbox activity (architecture §10, §11; WP-054). Both are written by the api
 * only; clients read them with listeners.
 */
/** The task fields a change records. Values are stored as text: a due date as `YYYY-MM-DD`, a person as a uid. */
export const TaskField = z.enum(["title", "notes", "due", "assignee", "status", "visibility"]);
export const TaskFieldChange = z.object({
    field: TaskField,
    before: z.string().nullable(),
    after: z.string().nullable(),
});
/** `workspaces/{ws}/tasks/{t}/changes/{id}`: one edit of a task, by one person. */
export const TaskChangeDoc = z.object({
    actorUid: Uid,
    changes: z.array(TaskFieldChange).min(1),
    at: z.date(),
});
export const ActivityEvent = z.enum(["dm", "mention", "message_edited", "task_assigned", "task_changed"]);
/**
 * `users/{uid}/activity/{id}`: one inbox row per conversation or task for the person it involves.
 * A newer event on the same conversation or task updates the row. Unread while `lastAt` is after
 * `readAt` (for a chat row, also after the person's read marker in that channel).
 */
export const ActivityDoc = z.object({
    kind: z.enum(["chat", "task"]),
    workspaceId: z.string().min(1),
    /** The channel or the task. */
    targetId: z.string().min(1),
    event: ActivityEvent,
    actorUid: Uid,
    /** The channel's name (a DM's other members) or the task's title, when the event happened. */
    title: z.string().max(300),
    snippet: z.string().max(300),
    /** Task rows: what changed since the person last read the row, oldest value first. */
    changes: z.array(TaskFieldChange).default([]),
    lastAt: z.date(),
    readAt: z.date().nullable().default(null),
    /** Taken out of the inbox; the next event puts it back. */
    done: z.boolean().default(false),
});
export const ActivityIdInput = z.object({ activityId: z.string().min(1).max(300) });
//# sourceMappingURL=activity.js.map